angular.module('TetherApp').controller(
	'ClientController',
	[
		'$window',
		'$mdDialog',
		'clientService',
		'shortcodeDataService',
		'keywordService',
		function (
			$window,
			$mdDialog,
			clientService,
			shortcodeDataService,
			keywordService
		) {
			let self = this;
			self.clients = [];
			self.clientId = null;
			self.shortcodeIds = '';
			self.allLanguages = [
				{
					'language' : 'en',
					'label' : 'English'
				},
				{
					'language' : 'fr',
					'label' : 'French'
				},
				{
					'language': 'pt-br',
					'label': 'Portuguese (Brazil)'
				}
			];
			self.availableLanguages = [];

			self.languageData = {
				"data" : []
			};

			self.showClientTypeWarning = false;

			self.inputShortcodes = [];

			self.init = function (clientId) {
				self.currentShortcodes = shortcodeDataService.getCurrentShortcodes();

				self.inputShortcodes = shortcodeDataService.getShortcodesData();

				if (self.currentShortcodes != undefined) {
					if (self.currentShortcodes === parseInt(self.currentShortcodes, 10)) {
						currentShortcodesArray = [];
						currentShortcodesArray.push(self.currentShortcodes);
					} else {
						currentShortcodesArray = self.currentShortcodes.split(",");
					}

					self.outputShortcodes = [];

					angular.forEach(self.inputShortcodes, function( value, key ) {
						if(currentShortcodesArray.indexOf(value.id) != -1){
							tempValue = value;
							tempValue.ticked = true;

							self.outputShortcodes.push(tempValue);
						}
					}, self);

				}
				self.updateShortcodes();

				self.clientId = clientId;

				if (self.clientId != null) {
					if (window.languageData != undefined) {
						self.clientLanguageLoad(window.languageData);
					} else {
						self.languageData = clientService.getClientLanguages(self.clientId).then(
							onClientLanguagesLoad,
							onError
						);
					}
				} else {
					if (window.languageData != undefined) {
						self.clientLanguageLoad(window.languageData);
					}
					self.updateLanguageDropdown();
				}
			};

			let onClientLanguagesLoad = function(result){
				self.clientLanguageLoad(result);
			};

			self.clientLanguageLoad = function(result){
				self.languageData = result;

				angular.forEach(self.languageData.data, function( value, key ) {
					self.updateSmsCounts(key);
					if (value.is_default == 1 || value.is_default == 'on') {
						value.is_default = true;
					} else {
						value.is_default = false;
					}

					if (value.opt_in == 1 || value.opt_in == 'on') {
						value.opt_in = true;
					} else {
						value.opt_in = false;
					}

				}, self);

				self.updateLanguageDropdown();
			};

			self.initClients = function () {
				clientService.getClient()
					.then(onClient, onError);
				self.getUsersClients();
			};

			self.getUsersClients = function () {
				clientService.getUsersClients()
					.then(onUsersClientsSuccess, onError);
			};

			self.updateShortcodes = function () {

				self.shortcodeIds = '';

				angular.forEach(self.outputShortcodes, function( value, key ) {
					if(self.shortcodeIds == '') {
						self.shortcodeIds = self.shortcodeIds + value.id;
					} else {
						self.shortcodeIds = self.shortcodeIds + ',' + value.id;
					}

				}, self);

				document.querySelector('#shortcodes').value = self.shortcodeIds;
			};

			self.setClient = function(clientId, clientName) {
				clientService.setSelectedClient(clientId, clientName)
					.then(onSetClientSuccess, onError);
			};

			let onClient = function (data) {
				self.client = data;
			};

			let onSetClientSuccess = function (data) {
				let url = '/';

				if (data.hasOwnProperty('url') && data.url) {
					url = data.url;
				}

				$window.location.href = url;
			};

			self.fetchUsersClients = function () {
				clientService.getUsersClients()
					.then(onUsersClientsSuccess, onError);
			};

			let onUsersClientsSuccess = function (data) {
				self.clients = data.clients;
			};

			let onError = function(reason) {
				self.error = 'Could not fetch the data.';
			};

			let DialogController = function ($mdDialog) {
				let dCtrl = this;
				dCtrl.parent = self;
				dCtrl.message = undefined;

				dCtrl.hide = function () {
					$mdDialog.hide();
				};

				dCtrl.cancel = function () {
					$mdDialog.cancel();
				};

				dCtrl.answer = function (answer) {
					$mdDialog.hide(answer);
				};

				let onSend = function (data) {
					// console.log('success');
				};

				let onError = function (data) {
					// console.log('error');
				};

			};

			self.clientSelector = function (ev) {
				DialogController.$inject = ['$mdDialog'];
				$mdDialog.show({
					controller: DialogController,
					controllerAs: 'clientSelectorController',
					bindToController: true,
					templateUrl: '/client/client-selector-pop-up',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true
				});
			};

			self.onLanguageInfoUpdate = function (language, currentKey){
				if(self.languageData.data[currentKey].is_default == true){
					angular.forEach(self.languageData.data, function(value, key){
						value.is_default = false;
						self.updateSmsCounts(key);
						$('#languageInfo[' + value.language + '][is_default]').val(value.is_default);
					}, self);
					self.languageData.data[currentKey].is_default = true;
					$('#languageInfo[' + language + '][is_default]').val(
						self.languageData.data[currentKey].is_default
					);
				} else {
					self.languageData.data[0].is_default = true;
				}

				// console.log('Update languageInfo: ' + language);
			};

			self.onLanguageInfoAdd = function (){
				// console.log('Add languageInfo: ' + self.currentLanguage);

				if(self.currentLanguage == undefined)
				{
					return;
				}

				label = '';

				angular.forEach(self.allLanguages, function( value, key ) {
					if (value.language == self.currentLanguage) {
						label = value.label;
					}
				}, self, label);

				if (self.languageData.data[0] == undefined) {
					is_default = true;
				} else {
					is_default = false;
				}

				self.languageData.data.push(
					{
						'language' : self.currentLanguage,
						'language_label' : label,
						'keyword' : '',
						'message' : '',
						'opt_in' : 0,
						'is_default' : is_default
					}
				);

				self.updateLanguageDropdown();
				self.currentLanguage = undefined;
			};

			self.onLanguageInfoDelete = function (language){
				// console.log('Delete languageInfo: ' + language);

				angular.forEach(self.languageData.data, function( value, key ) {
					if (value.language == language) {
						self.languageData.data.splice(key, 1);
					}
				}, self);

				angular.forEach(self.languageData.data, function(value, key){
					value.is_default = false;
				}, self);

				if(self.languageData.data[0] != undefined){
					self.languageData.data[0].is_default = true;
				}

				self.updateLanguageDropdown();
			};

			self.updateLanguageDropdown = function(){
				// console.log('Updating Language Dropdown');

				self.availableLanguages = [];
				angular.forEach(self.allLanguages, function( value, key ) {
					addToArray = true;
					angular.forEach(self.languageData.data, function( languageDataValue, languageDataKey ) {
						if (value.language == languageDataValue.language) {
							addToArray = false;
						}
					}, self, addToArray);
					if (addToArray) {
						self.availableLanguages.push(value);
					}
				}, self);
			};

			self.validateLanguages = function(event) {
				event.preventDefault();
				angular.forEach(self.languageData.data, function(value, key) {
					value.is_keyword_valid = false;
					value.is_message_valid = false;
					value.is_keyword_length_valid = false;
					value.is_keyword_shortcode_valid = false;
				}, self);

				self.hasLanguage = false;

				if (self.languageData.data.length == 0) {
					self.hasLanguage = false;
					$('#language_required_error').show();
				} else {
					self.hasLanguage = true;
					$('#language_required_error').hide();
				}

				angular.forEach(self.languageData.data, function(value, key){
					if (value.message.length < 20) {
						value.is_message_valid = false;
						$('#' + value.language + '_message_length_error').show();
					} else {
						value.is_message_valid = true;
						$('#' + value.language + '_message_length_error').hide();
					}

					if (value.keyword.length < 3) {
						value.is_keyword_length_valid = false;
						$('#' + value.language + '_keyword_length_error').show();
					} else {
						value.is_keyword_length_valid = true;
						$('#' + value.language + '_keyword_length_error').hide();
					}

					if (self.shortcodeIds == '') {
						value.is_keyword_shortcode_valid = false;
						$('#' + value.language + '_keyword_set_shortcode_error').show();
					} else {
						value.is_keyword_shortcode_valid = true;
						$('#' + value.language + '_keyword_set_shortcode_error').hide();
					}

					if (value.is_keyword_length_valid && value.is_keyword_shortcode_valid) {
						value.is_keyword_valid = false;
						keywordService.getKeywordByKeywordAndShortcode(
							value.keyword,
							self.shortcodeIds.split(',')[0],
							key,
							value.keyword_id
						)
							.then(onKeywordLoad, onError);
					}
				}, self);
			};

			let onKeywordLoad = function(result){
				if(result.id != undefined)
				{
					self.languageData.data[result.key].is_keyword_valid = false;
					$('#' + self.languageData.data[result.key].language + '_keyword_not_available_error').show();
				} else {
					self.languageData.data[result.key].is_keyword_valid = true;

					$('#' + self.languageData.data[result.key].language + '_keyword_not_available_error').hide();

					angular.forEach(self.languageData.data, function(value, key){
						if(key != result.key && value.keyword == self.languageData.data[result.key].keyword)
						{
							self.languageData.data[result.key].is_keyword_valid = false;
							$('#' + self.languageData.data[result.key].language + '_keyword_not_available_error').show();
						}
					}, self);

					self.allLanguageInfoValid = null;

					angular.forEach(self.languageData.data, function(value, key){
						value.all_valid =
							value.is_keyword_valid
							&& value.is_keyword_length_valid
							&& value.is_keyword_shortcode_valid
							&& value.is_message_valid;

						if(self.allLanguageInfoValid == null){
							self.allLanguageInfoValid = value.all_valid;
						} else {
							self.allLanguageInfoValid = self.allLanguageInfoValid && value.all_valid;
						}
					}, self);
					//CHECK ALL VALID
					if(self.allLanguageInfoValid)
					{
						$('form').submit();
					}
				}
			};

			self.populateByShortcodeId = function (shortcodeIds) {
				let tempShortcodes = shortcodeIds;
				if (tempShortcodes == undefined) {
					tempShortcodes = $window.current_shortcodes;
				}
				if (tempShortcodes != undefined && (self.outputShortcodes == undefined || self.outputShortcodes.length == 0)) {
					let tempInputShortcodes = self.inputShortcodes;
					self.outputShortcodes = [];
					for (let index in tempInputShortcodes) {
						if (tempShortcodes.indexOf(tempInputShortcodes[index]['id']) !== -1) {
							let tempObject = tempInputShortcodes[index];
							tempObject.ticked = true;
							self.outputShortcodes.push(tempObject);
						}
					}
					self.updateShortcodes();
				}
			};

			self.updateSmsCounts = function(key) {
				self.languageData.data[key].message_length = self.languageData.data[key].message.length;
				self.languageData.data[key].message_count = Math.ceil(self.languageData.data[key].message_length / self.sms_character_limit);
			};

			self.reset = function (clientId) {
				if (confirm("Reset participant data?")) {
					clientService.reset(clientId)
						.then(
							function () {
								alert('Reset complete.');
							},
							onError
						);
				}
			};
		}
	]
);
